// 《梭哈宣言》v1 — 中文版
// 作者署名：ALLIN 社区
//
// Structure:
//   sections: [{ id, kind, title, paragraphs[], pullQuote?, list?, subsections? }]
//   - kind: 'preface' | 'chapter' | 'section' | 'pending'
//   - paragraphs: array of strings (each string = one <p>)
//   - pullQuote: optional string, rendered as a visual highlight quote
//   - list: optional { title, items[] }
//   - subsections: nested sections (used for ch2 three principles)

export const MANIFESTO_ZH = {
  meta: {
    title: '梭哈宣言',
    subtitle: '一份给把全部押在一件事上的人的备忘录',
    author: 'ALLIN 社区',
    edition: '初版 · 2026 春',
  },
  sections: [
    {
      id: 'preface',
      kind: 'preface',
      number: '',
      title: '前言',
      pullQuote: '梭哈，是这一代人最被误解的浪漫。',
      paragraphs: [
        '我们想用一句话开宗明义：梭哈，是这一代人最被误解的浪漫。',
        '这一份不是白皮书。',
        '白皮书会告诉你协议架构、共识机制、Tokenomics 的精妙设计；会画出一份分四个阶段的路线图，每一步看起来都通向月亮。我们写不出来这种东西。$ALLIN 不是一个 L1，不是一个 DeFi 协议，没有什么"技术突破"——它的合约就是一个标准的 BEP20，朴素得连一行多余的 require 都没有。',
        '那为什么还要发币？',
        '因为我们想给一种已经存在了几十年、但从未被认真命名的精神，立一座路标。它在巴菲特身上，在段永平身上，在马斯克的 2008 年，在雷军的小米粥，在赵长鹏卖掉的那套上海房子里。它不属于哪个国家、哪个行业，但它在每一次伟大决策的背后都出现过。',
        '我们叫它"梭哈"。',
        '代币是把这种共识标价、确权、记账最快的方式。这份《梭哈宣言》——以及它所代表的这个项目——是给所有把全部押在一件事上的人的一座纪念碑，也是写给所有正在那个边界上犹豫的人的一封信。',
        '如果你读完之后觉得"这就是我"——欢迎入桌。',
      ],
      sign: '——ALLIN 社区',
    },

    {
      id: 'ch1',
      kind: 'chapter',
      number: 'I',
      title: '为什么是 ALLIN',
      paragraphs: [
        '我们活在一个鼓励对冲的时代。',
        '对冲基金管的是钱，但"对冲"早就溢出了金融行业，变成了一种世俗智慧。投资要分散，工作不要 All In 一家公司，关系要保留备胎，时间要切割成多个并行的项目。每个时代都有自己的金科玉律——这一代的金科玉律是"不要把所有鸡蛋放在一个篮子里"。',
        '听起来很安全。代价是，所有篮子都装不满。',
        '我们不反对分散。分散对那些不知道自己在做什么的人，是最负责任的选择。它给了一个不会致命的下行边界。问题是，分散同时也给了一个不会非凡的上行边界——它把你的人生变成了一种均值回归的产品。',
        '这一代真正的赢家，没有一个是分散出来的。',
        '巴菲特的伯克希尔，在很长一段时间里，把 70% 的仓位压在不到十只股票上；那十只里面，还有一只占了将近一半。这不是分散——这是研究透了之后的集中。段永平在 2001 年把网易当做唯一的押注，全部身家进去，三年回报五十倍。雷军 40 岁前已经财富自由，他没有继续做天使投资人在多个赛道同时下小注，他选择把自己投到一家公司里，喝下那碗小米粥。马斯克在 2008 年只剩下最后一颗火箭可以发射的钱，他没有把它分成 ABC 三轮"风险测试"，他直接押了第四发。',
        '这些人共享的，不是某种神秘的赌徒人格。恰恰相反——他们都是当时所在行业里研究最深、信息最全、风险评估最严谨的人之一。他们之所以敢梭哈，是因为他们看清了。',
      ],
      pullQuote: '梭哈不是赌运气。梭哈是看清楚之后，把全部筹码推过去的勇气。',
      paragraphsAfterQuote: [
        '但是这个词在过去十年里被反复污名化。"梭哈"在很多人耳朵里等同于"赌徒"、"散户冲动"、"All in 然后归零"。这是一种巨大的语义偷换。**真正的梭哈者从不依赖运气，他们依赖的是研究的深度，加上把研究兑现的勇气**。运气派那是另外一群人，叫"赌徒"——他们也常常 All in，但是他们 All in 在一个自己根本看不懂的东西上，所以归零是必然的。',
        'ALLIN 想做的第一件事，就是把"梭哈"这个词从赌徒手里夺回来。',
        '第二件事，是把它从专属于商业精英的词典里，拿出来交给所有人。',
        '不是只有创业者可以梭哈。一个程序员决定从大厂辞职专心写自己的开源项目——那是梭哈。一个学生决定大学只学一门，把所有时间倒进 AI 研究——那是梭哈。一个家庭决定卖掉北京的房子全部投入子女在新西兰的教育——那是梭哈。一个普通人决定把全部业余时间和积蓄做一件事十年——那也是梭哈。',
        '梭哈不属于赛道，不属于资产规模，不属于任何身份。它只属于一种姿态：**研究透、押全部、愿赌服输**。',
        '那为什么用代币？',
        '因为代币是这一代最快的共识容器。一篇文章传播需要几年才能形成圈层；一本书需要十年才能塑造一种文化；一种宗教需要百年才能稳定下来。但代币——一个透明、可交易、链上可证、共识可标价的东西——可以在几个月里聚集起一群人，让他们彼此找到、彼此确认。',
        '我们不指望 $ALLIN 解决某个"实际问题"。这枚代币没有实用功能。它是一座纪念碑，一种暗号，一份名单——名单上是所有在自己生命里把全部押在一件事上的人。',
        '最后划一条线：ALLIN 不是 Trump 主题、不是 Doge 续作、不是任何一只蹭热点的 meme。它是中文语境里**梭哈精神**的一次正式立碑。Logo 上那只举拳的金色 Doge，不是借用 Trump 的姿势——它本身就是这一代人最熟悉的"我看清楚了，我下注"的肢体语言。',
        '它跟 Doge 借用过那个动作，但精神来自更深的地方。',
      ],
    },

    {
      id: 'ch2',
      kind: 'chapter',
      number: 'II',
      title: '三条精神原则',
      paragraphs: [
        '整个项目所有的判断、所有的决策、所有的内容收录标准，都来自这三条。',
      ],
      subsections: [
        {
          id: 'ch2-1',
          number: 'I',
          title: '看懂了，就梭哈',
          paragraphs: [
            '这一条决定了我们如何看待"研究"和"下注"的关系。',
            '业内有两种主流声音。一种是巴菲特的"安全边际"——只买那些价格远低于内在价值的资产，留出足够缓冲。另一种是段永平的"不为清单"——把自己一辈子不会做的事写下来，剩下的领域才进入研究范围。表面看是两种方法，本质是同一件事：在做出重大决策之前，先把"看不懂的"全部排除干净。',
            '排除干净之后，会发生一件有趣的事情：可下注的标的变得很少。',
            '少到什么程度？巴菲特在自己最赚钱的几十年里，平均每年只做一两个真正重大的下注。段永平公开承认过，他人生重大决策不超过五次，每一次都集中下注。这不是因为他们懒——是因为他们知道，**真正能看懂的东西本来就不多**。',
            '这反过来给了一个推论：当你真的看懂一件事的时候，分散下注是一种自我背叛。',
            '如果你研究透了网易，确认它的现金储备超过市值，你为什么只买 10%？你既然已经做了 90% 的研究工作，剩下 10% 凭什么不押上去？除非你怀疑自己的研究——但如果你怀疑，那你应该再研究，而不是用"分散"来掩盖你的不确定。',
            '凯利公式给这件事提供了数学背书。在已知胜率和赔率的情况下，最优下注比例往往远高于普通投资者敢押的金额。一个 60% 胜率、1.5:1 赔率的机会，凯利建议下注全部资金的 33%——而不是 5%、不是 10%。',
            '我们说"看懂了就梭哈"，不是鼓励冲动。是在劝退两类人：',
          ],
          list: {
            items: [
              '**第一类，你其实没看懂，但 FOMO 促使你下注。** 那叫赌。回去研究。',
              '**第二类，你看懂了，但只下了一点点。** 那叫怯懦。把它兑现。',
            ],
          },
          paragraphsAfterList: [
            '中间的那条窄路，才是梭哈。',
            '判断"看懂"的最低门槛，我们建议三条：',
          ],
          checklist: {
            items: [
              '你能用 5 分钟，对一个聪明但不懂这个领域的人，把它讲清楚。',
              '你能列出三种这个押注会失败的方式，并且知道每一种的概率。',
              '在最坏的情况下，你的生活仍然可以继续，不会出现"还不上的债"或者"挽不回的关系"。',
            ],
          },
          paragraphsTail: [
            '第三条尤其关键。我们不是在鼓励豪赌——我们是在分清梭哈和豪赌的边界。真正的梭哈者，押的是"全部可输的钱"，而不是"全部能借到的钱"。这是一种对自己生活诚实的克制。',
          ],
        },

        {
          id: 'ch2-2',
          number: 'II',
          title: '愿赌服输',
          paragraphs: [
            '这一条决定了我们对自己、对持有人、对市场的态度。',
            'ALLIN 不承诺收益。',
            '我们想把这句话再强调一遍——ALLIN **不**承诺收益。这枚代币的合约里没有质押 APY，没有回购销毁机器，没有定期分红。我们不会在任何 KOL 的视频里说"100x 在路上"，也不会在任何 X 帖子里画"目标价"。',
            '我们承诺的只有一件事：真实。',
            '合约真实——LP 已经永久销毁，链上可查；分配真实——没有团队预留、没有顾问解锁；故事真实——所有收录的梭哈案例都基于公开可验证的资料。仅此而已。',
          ],
          pullQuote: '我们不卖梦，只卖一份诚实的契约：你看到什么，就是什么。',
          paragraphsAfterQuote: [
            '这意味着我们必须主动拒绝两种行业惯性。',
            '第一种是"路线图魔法"。绝大多数代币项目会画出 Phase 1 / 2 / 3 / 4，每一步都看起来精确、有节奏、不可阻挡。**我们没有 Phase 4**。我们只承诺当下能落地的事，不承诺一年后会发生什么——因为社区共识本身是流动的，明年的路线该由明年的社区决定，而不是由今天写文档的人决定。这听起来不专业，但它是诚实的。',
            '第二种是"维持共识"。当一个 meme 币起跑之后，操盘者会做的事情通常是：拉群、喊单、安排买盘、稳住情绪、让价格不要回调太多。我们不做这些。**ALLIN 的价格涨跌完全反映社区当下的真实信仰强度**——共识强了，价格自然涨；共识弱了，价格自然回。我们不会在它弱的时候用任何手段"托盘"，因为托盘是对持有人最大的不诚实，它制造了一个"还有人在守"的假象，最后买单的还是相信这个假象的人。',
            '愿赌服输的核心，是接受这件事可以归零。',
            '不是说它一定会归零，而是说我们——项目方、核心持有人、社区贡献者——都对这种可能性 100% 知情，并且在知情之后依然选择留在桌上。这种"在知情之下的留下"，是 ALLIN 唯一可信的护城河。',
            '为持有人提的建议：用你输得起的钱押。我们说的"输得起"不是金额——是这笔钱归零之后你的生活、你的关系、你的健康都不会发生质变。如果你正在用还不起的钱来梭哈，那你不是这份宣言的读者；你是赌徒。请离开。',
            '公开输了也是骄傲。',
            '如果有一天 $ALLIN 归零，社区会公开发布最后一份记录，列出全部已收录的故事、全部贡献者、全部链上数据，封档。它不会偷偷下线，不会改名重启，不会被洗成另一个项目。**输了的故事，跟赢了的故事一样值得被记下来**——因为它们一样真实地承载了那个时刻把全部押上去的人的勇气。',
          ],
        },

        {
          id: 'ch2-3',
          number: 'III',
          title: '只做长期主义者的同路人',
          paragraphs: [
            '这一条决定了我们想吸引谁、远离谁。',
            '最容易被误解的，是"长期主义"这四个字。它现在被滥用到了几乎失去意义——拿一只跌了 30% 的股票被套，叫做"长期持有"；做一份七年没起色的工作还不离开，叫做"长期投入"；维持一段早就互相消耗的关系不分手，叫做"长期承诺"。这些都不是。',
          ],
          pullQuote: '长期主义不是被动等待。长期主义是把每一年都当作可能是最后一年，依然选择继续下注。',
          paragraphsAfterQuote: [
            '它是主动的、不断重新评估的、随时可以撤出但选择不撤出的姿态。如果你只是因为"沉没成本"而不动，那不叫长期主义，那叫惯性。',
            'ALLIN 想找的同路人，是那些把"梭哈"当作一种生活方式而不是一次性事件的人。这意味着：',
          ],
          checklist: {
            items: [
              '他们对自己的研究持续保持怀疑，看到反证会调整。',
              '他们在赢的时候不张扬，在输的时候不消失。',
              '他们押全部，但永远只押"下一件最重要的事"，而不是停留在过去的那一件。',
              '他们对其他长期主义者有天然的尊重，哪怕赛道不同、判断不同。',
            ],
          },
          paragraphsTail: [
            '这就是为什么 ALLIN 的核心内容，是收录大佬的梭哈故事。这些故事不是用来"信仰营销"——它们是给我们和我们的同路人看的备忘录：**梭哈不是某个时代独有的，它每一代都有，每个行业都有**。',
            '我们想留下一份长名单。',
            '名单上的人，可能是任正非那样的工业家、巴菲特那样的资本家、马斯克那样的工程师、孙宇晨那样的币圈玩家、王兴那样的连续创业者；也可能是某个我们还没听说过的、正在某个小城市的出租屋里把全部时间砸到一件事上的年轻人。这份名单不分国籍、不分行业、不分阶级——唯一的入场券是把全部押在一件事上。',
            '如果你正在做这样一件事——欢迎来投稿。第三章的《梭哈者列传》会持续更新，每一条入选的故事都会被永久保留在链上和这份宣言里。我们会用 10% 的代币池给到入选者。但坦诚说：**真正会被这个项目吸引的人，不是为了那 10%——他们是为了被记下**。',
            '被记下，是一种古老的奖励。它比 token 古老得多，可能也持久得多。',
          ],
        },
      ],
    },

    {
      id: 'ch3',
      kind: 'chapter',
      number: 'III',
      title: '梭哈者列传',
      paragraphs: [
        '这一章不是为了崇拜。',
        '我们不想把这九个人神化——他们都有自己的局限、争议、失误。任正非以"狼性"著称但也压榨过员工；段永平偶尔也会看错；马斯克的 X 收购至今争议不断；孙宇晨的诸多商业决策被 SEC 起诉。',
        '我们要记下的不是他们这个人，而是他们在某一个具体的瞬间做出的"梭哈"决策。在那一刻，他们都站在悬崖边上，把全部筹码推了过去。那一刻的勇气、那一刻的判断、那一刻的"看清之后不犹豫"——这些是我们想留下来的。',
        '九个人，九个不同的行业，九种不同的押注。但他们共享一种姿态。',
        '按时间排序——从 1987 年的深圳南油，到 2017 年的镜头前。',
      ],
      subsections: [
        {
          id: 'ch3-1',
          number: '01',
          title: '任正非 · 2.1 万元起家（1987）',
          paragraphs: [
            '1944 年的贵州山区，任正非出生在一个有七个孩子的中学教师家庭。父亲教书，母亲也是教师，但子女多、收入薄。文革开始后，父亲因为"右派"嫌疑被批斗、隔离、劳改。任正非作为长子，承担起照顾弟妹的责任。他后来回忆，自己十八岁去重庆建筑工程学院读书前，"从来没有吃过一顿饱饭"。',
            '1968 年大学毕业，任正非被分配到军队基建工程兵部队，做工程师。从军 14 年，从普通技术员做到副团级。1983 年部队整编，他和数十万军人一起转业，安置在深圳南海石油后勤服务基地。',
            '1987 年的某一天，任正非在一笔合作里被骗走 200 万元——一笔在当时相当于他几辈子工资的金额。妻子提出离婚。父亲在贵州老家病逝。43 岁的他，失业、负债、单身，要养活两个孩子和年迈的母亲。',
            '1987 年 9 月 15 日。深圳南山区南油新村 A3 栋 16 楼 16D，一间不到 80 平方米的民房。任正非和五个朋友凑了 21,000 元人民币——其中包括他向亲友借的几千块——注册了一家公司。',
            '公司起名"华为"。"中华有为"四个字的简称。',
            '第一年，华为只是一家程控用户交换机的代理商。任正非自己跑业务、谈合同、催款、装机。深圳的夏天 38 度，他穿着衬衫挨家挨户拜访客户。一位早期员工回忆，那时候任老板"瘦得脱形"。',
            '但代理生意做到第二年，他做了一个改变华为 30 年命运的决定：自研。',
            '当时国内通信市场被"七国八制"垄断——七个国家的八种制式，全部是西方品牌：朗讯、北电、阿尔卡特、西门子、富士通、爱立信、NEC……国产货寥寥无几。任正非把代理生意的全部利润倒进研发。',
            '1991 年下半年，自研产品 HJD48 量产成功。1993 年，华为投入 5000 万人民币（相当于公司当年全部利润）研发万门程控交换机 C&C08。这是另一次梭哈——研发周期一旦延误，公司就会破产。',
            '1994 年 C&C08 量产成功。这一年华为销售额突破 8 亿。任正非在年会上说出那句后来被反复引用的话：',
          ],
          pullQuote: '"十年之内，世界通信制造业三分天下，华为有其一。"',
          paragraphsAfterQuote: [
            '任正非的梭哈不是赌博式的，是绝境式的。1987 年的他没有"分散下注"的资格——他没有钱可以分散，没有第二次机会可以拆分。被骗 200 万、负债、离婚、父亲过世，把他推到了一个"必须 All In 一件事"的位置上。',
            '但他选择 All In 在哪里，是经过判断的。通信行业在 1987 年的中国是一片荒地——一边是国家急需（电话普及率不到 1%），一边是国产玩家几乎为零。任正非看出这是一个 30 年级别的窗口：通信网络一旦建起来，迭代的速度跟基础设施一样慢，先发优势是结构性的。',
            'C&C08 的梭哈则是他第二次"绝境式"决策。1993 年 5000 万的研发投入，对当时只有 270 名员工的华为来说，是把全部当年利润押了进去。如果交付失败——不是延期半年那种失败，是产品不达标——华为会立刻破产。',
            '后来他自己写《华为的冬天》《北国之春》——一系列内部讲话，全部围绕一个主题：**危机感是华为唯一的护城河**。',
            '1996 年开始海外扩张，2002 年进入欧洲，2010 年成为全球第二大通信设备商，2018 年超越爱立信成为第一。2018 年 12 月孟晚舟在加拿大被捕，开启美国对华为的制裁。2020 年禁令升级，华为被切断台积电的芯片供货。手机业务一度跌掉 70% 收入。',
            '任正非在内部讲话里只说了两句："最艰难的时刻还在后面。" "我们要把眼泪擦干，继续前进。"',
            '2023 年 8 月 29 日，华为 Mate 60 Pro 在毫无预热的情况下上市，搭载完全自研的麒麟 9000s 芯片。海外科技媒体一片哗然——华为被认为已经被打死的芯片设计能力，居然以国产工艺重生。',
          ],
          checklist: {
            items: [
              '**绝境式梭哈往往最纯粹**——你没有退路，所以你不会犹豫。',
              '**43 岁创业不晚**——把"年龄优势"拿掉之后，剩下的是判断力和韧性，那些都不会因为年龄消失。',
              '**选 30 年级别的赛道**——通信、电力、医疗，这些行业的迭代周期长，先发优势可以累积。',
              '**危机感是护城河**——任正非用 30 年告诉我们，最危险的不是危机本身，是没有危机感。',
            ],
          },
        },

        {
          id: 'ch3-2',
          number: '02',
          title: '段永平 · 网易抄底（2001）',
          paragraphs: [
            '1961 年江西南昌生。1989 年，28 岁的段永平加入广东中山一个濒临倒闭的小厂——"日华电子厂"。他做的第一件事，是把厂里一款 8 位红白机改头换面，重新包装成"小霸王"学习机。1992 年请成龙代言：「拥有一台小霸王，等于拥有一个微机室」。广告费 5000 万——当年全中国电视广告费的零头。',
            '1995 年小霸王做到 10 亿营收。但段永平和老板谈股权改制，老板拒绝。他选择带着核心团队离开，到东莞创办"步步高"——做无绳电话、复读机、DVD、后来是音乐手机。同样请成龙代言，同样的营销手法，同样的现金奶牛。',
            '到 2001 年，40 岁的段永平把步步高的经营权交给团队，自己移居美国硅谷。他打算"半退休"——读书、打高尔夫、研究投资。',
            '2001 年是互联网泡沫破灭最惨烈的一年。纳斯达克从 5048 跌到 1100。中国概念股在美国受到严重打击。',
            '网易（NTES）是其中跌得最惨的一个。2001 年 7 月，网易因为 2000 年报披露不准确被 SEC 调查，股价从 IPO 时的 15 美元一路跌到当年 9 月的 0.6 美元——跌幅 96%。复牌后，几乎没有人敢碰这只股票。',
            '段永平刚到美国不久，开始关注美股。他研究网易的财报：',
          ],
          list: {
            items: [
              '公司账上现金 4400 万美元',
              '当时市值不到 2000 万美元',
              '主营游戏（《大话西游 II》）、邮箱、广告，都还有正向现金流',
              '创始人丁磊持股 50%，本人没跑路',
            ],
          },
          paragraphsAfterList: [
            '简单说：**这家公司账上的钱比它的市值还多**。买它，相当于花 5 毛钱买 1 块钱的现金。',
            '段永平花 200 万美元买入网易。',
          ],
          pullQuote: '"我对互联网懂的不多，但我对人性懂的足够。"',
          paragraphsAfterQuote: [
            '他的逻辑很简单。第一，这是典型的"安全边际"案例——即使网易明天关门，清算之后股东能拿回的钱也比股价多。下行风险被现金锁死了。第二，丁磊是熟人——段永平在步步高时期跟丁磊有过商业往来，他相信丁磊不是会跑路的人。第三，丁磊正在带团队做一款叫《梦幻西游》的游戏，公司账上有钱、有团队、有产品方向，缺的只是市场情绪。',
            '段永平后来说："我赌的不是网易必涨——我赌的是哪怕归零，我也认了。"',
            '他的仓位规模也是关键。$200 万对他来说不是全部身家，但是他单一股票最大仓位之一。这不是分散的"安全边际"——这是经过研究后的集中下注。',
            '2003 年初，《梦幻西游》上线，迅速成为中国第一国民端游。网易股价从 0.6 美元爆发到 70 美元——18 个月，翻了 100 倍。段永平的 200 万变成了大约 2 个亿。但他没卖。他持有网易长达 20 多年，期间陆续减仓但从未清空。',
            '第二次梭哈在 2011 年。乔布斯去世，市场担心苹果失去灵魂，股价回调。段永平大举买入苹果。他的理由："苹果的 iOS 生态、产品哲学、用户粘性，这些不会因为一个人离开而消失。" 10 年后，苹果股价从他买入的均价涨了 3-4 倍。',
            '中间他还有过一次小赌——2010 年代投资腾讯、2018 年投资茅台。每一次都是研究透了再下大注，没有一次是分散赌博。',
          ],
          checklist: {
            items: [
              '**现金多于市值的标的，是上帝级别的安全边际**。这种机会一辈子遇到不超过五次，遇到了不要只下一点点。',
              '**"不为清单"比 to-do list 更重要**。把不会做的领域、不熟悉的行业、看不懂的商业模式，全部排除掉，剩下的才是研究范围。',
              '**大注 + 长期持有，比短炒赚得多**。段永平这一辈子真正的大决策不超过 5 次，但每次都是大注，并且持有到生意本身改变。',
              '**价值投资 ≠ 不能集中**。巴菲特和段永平都是集中下注派。"分散是无知者的避难所"——巴菲特原话。',
            ],
          },
        },

        {
          id: 'ch3-3',
          number: '03',
          title: '马斯克 · 第四次发射（2008）',
          paragraphs: [
            '1971 年南非比勒陀利亚生。10 岁拿到第一台电脑，12 岁靠卖一款叫 Blastar 的游戏赚到 500 美元。17 岁离开南非去加拿大，因为不想服兵役。',
            '1995 年，24 岁的马斯克在 Stanford 拿到物理博士项目入学资格，但两天后辍学，跟弟弟创办 Zip2。1999 年 Zip2 卖给 Compaq，他个人到手 2200 万美元。同年他用绝大部分钱创办 X.com，做在线银行。后来 X.com 跟 Confinity 合并，改名 PayPal。2002 年 eBay 收购 PayPal，马斯克作为最大个人股东到手 1.8 亿美元。',
            '如果他选择"分散下注"或"提前退休"，他可以在 31 岁的时候做一辈子的天使投资人。但是他做了相反的事。',
            '2002 年 6 月，他用 1 亿美元创办 SpaceX。2004 年，他用剩下的 7000 万投资 Tesla，并担任 CEO。2006 年参与创办 SolarCity。',
            '到了 2008 年，他三家公司全部濒临破产。',
            '2008 年是马斯克这辈子最接近归零的一年。SpaceX 已经发射 Falcon 1 三次，三次全部失败：',
          ],
          list: {
            items: [
              '2006 年 3 月 24 日：发射 33 秒后燃料管路漏油，火箭坠毁',
              '2007 年 3 月 21 日：第一级和第二级分离时碰撞，火箭失控',
              '2008 年 8 月 3 日：第二级提前关机，载荷未能入轨',
            ],
          },
          paragraphsAfterList: [
            'SpaceX 账上的钱只够再做最后一次发射。',
            'Tesla 的情况更差。Roadster 跳票一年多，工厂建设超支，2008 年金融危机让所有 VC 关上了钱包。Tesla 账上的钱不够发当月工资。',
            '马斯克的 1.8 亿美元个人财富——他在 PayPal 卖出之后所有的钱——已经全部投入这两家公司，外加他自己被烧掉的几千万。他在 2008 年 9 月接受采访时说："我现在只剩下我妻子的车和孩子的学费基金。"',
            '那个秋天，他做了一个决定：把最后的 3000 万美元——他全部能动用的现金——全部投入 SpaceX 第四次发射。',
            '2008 年 9 月 28 日，Falcon 1 第四次发射。这一次成功了。Falcon 1 成为人类第一枚由私人公司研发并入轨的液体燃料火箭。紧接着，2008 年 12 月 23 日（圣诞节前两天），NASA 给 SpaceX 一份 16 亿美元的货运合同。同时 Tesla 在 2008 年 12 月底完成 D 轮 4000 万美元融资，加上马斯克自己借来的 2000 万（用婚戒和房子做抵押），Tesla 撑过了那个圣诞节。',
          ],
          pullQuote: '"我们 either 让这枚火箭飞起来，要么这家公司就死了。没有 third option。"',
          paragraphsAfterQuote: [
            '2008 年 9 月那个梭哈点，马斯克手里有几个选择：A. 把 3000 万分成 3 笔给三家公司各一份；B. 全部押给 Tesla，因为汽车行业是更大的市场；C. 全部押给 SpaceX 第四发，赌一次成功。',
            '他选了 C。理由有三：',
            '第一，**SpaceX 的数学是确定的**。火箭技术的失败模式有限，前三次失败的原因都已经修复。第四次的胜率是他能够计算的。Tesla 的市场反应、消费者接受度、金融环境——这些是他算不出来的。',
            '第二，**SpaceX 一旦成功，会立刻拿到 NASA 的合同**。这等于是一笔"如果我赢了，奖金已经在路上"的押注。马斯克在 2008 年初就跟 NASA 签了 COTS 项目协议——只要发射成功就能解锁付款。',
            '第三，**Tesla 还有融资可能，SpaceX 没有**。VC 不投火箭。SpaceX 必须靠自我证明（一次成功发射）才能改变这一点。',
            '到 2024 年，SpaceX 估值超过 4000 亿美元（是世界上估值最高的私营公司），Tesla 巅峰市值超过 1.5 万亿美元。但是这些都是"梭哈成功之后的故事"。如果 2008 年 9 月 28 日那次发射失败，没有人会记得 SpaceX，Tesla 也会在 2009 年初破产。',
          ],
          checklist: {
            items: [
              '**算的清的赌注，可以集中下**。马斯克 2008 年敢全押 SpaceX，是因为他能列出第四次发射的所有失败模式，并且每一种都有解决方案。',
              '**押在"一次成功就改变规则"的事上**。NASA 合同是悬在头顶的奖励，马斯克知道一次发射成功能解锁多少美元。',
              '**婚戒可以抵押，时间不可以**。当现金不够的时候资产可以变现；但当时间不够的时候，没有任何东西可以替代。',
              '**"All In" 不是一次性事件**。马斯克 2008 年 All In 之后，2018 年 Tesla 量产危机时再次 All In，2022 年收购 Twitter 又一次 All In。',
            ],
          },
        },

        {
          id: 'ch3-4',
          number: '04',
          title: '雷军 · 一碗小米粥（2010）',
          paragraphs: [
            '雷军 1969 年生于湖北仙桃，父母都是普通教师。1987 年考入武汉大学计算机系。大三那年（1989 年）他和同学合伙创业，做仿制 BBS 软件。1991 年 22 岁的他认识金山的求伯君，被吸纳进金山。1998 年 29 岁担任金山 CEO。',
            '在金山的 16 年里，他带领团队推出了 WPS、词霸、毒霸、剑侠情缘——但跟微软的对抗一直没赢，金山始终是中国软件行业的"老二"。',
            '2007 年 10 月 9 日，金山在港交所上市。雷军因为身体原因（压力太大引发的心律问题）辞去 CEO，转任副董事长。38 岁的他，财富自由，准备半退休。',
            '接下来三年（2007-2010），他成为中国早期最活跃的天使投资人之一。投了 UC 浏览器、凡客诚品、YY、多看阅读、可牛影像、乐淘网等十几家公司——光 UC 浏览器一笔回报就超过 30 亿。',
            '但他在 40 岁前夕，开始焦虑。',
            '2010 年 4 月 6 日，北京中关村银谷大厦 807 室。雷军和六位合伙人——林斌、黎万强、周光平、刘德、黄江吉、洪锋——七个人围坐在一张桌子前。雷军端来七碗小米粥。每个人喝一碗。然后开始干。',
            '公司起名"小米"。"小米加步枪"——农村包围城市的战术；同时，小米是"米粒级"的细节工艺——做产品要一颗米一颗米地抠。',
          ],
          pullQuote: '"如果不创业，40 岁之后我都不知道怎么向自己交代。"',
          paragraphsAfterQuote: [
            '天使投资人的工作是"广撒网，抓概率"。雷军在 2007-2010 年的天使投资生涯里，已经是中国最赚钱的天使投资人之一。如果他继续做下去，每年躺着赚十几亿是确定的。为什么放弃这种舒服的生活？',
            '雷军在多次访谈里讲过："我做了 18 年程序员，做了 16 年金山 CEO。我一辈子最遗憾的，是没有做出过一款世界级的产品。我跟比尔盖茨同时代，我跟乔布斯同时代，我跟拉里佩奇同时代。但我没做出一个 Windows，没做出一个 iPhone，没做出一个 Google。"',
            '他的判断是：**移动互联网是 30 年级别的窗口**。iPhone 在 2007 年发布，Android 在 2008 年开源，2010 年是中国从功能机切换到智能手机的拐点。错过这一波，下一次机会要等 20 年。**硬件公司用互联网模式做，是中国独有的机会**——中国有最完整的电子供应链（深圳）、最大的人口基数、最便宜的渠道成本（互联网直销）。',
            '押全部，是因为他算清了：天使投资可以分散，但创办一家世界级公司必须 All In。"做产品的人，不能既做这家又做那家。"',
            '2011 年 8 月 16 日，小米手机 1 发布。1999 元定价、双核处理器、4 英寸屏——参数超过当时同价位的所有竞品。第一次开放购买，30 万台手机几分钟内售罄。',
            '2018 年 7 月 9 日，小米在港交所上市，市值 540 亿美元。雷军当天的演讲流出一句金句："站在风口上，猪都能飞起来。"',
            '2024 年，雷军 55 岁的时候，小米 SU7 电动车发布——这是他第二次梭哈。2024 年小米市值重回千亿美元级，雷军成为中国互联网新一代的"流量顶流"。',
          ],
          checklist: {
            items: [
              '**财富自由不是终点，是新一轮梭哈的起点**。真正的长期主义者，永远在梭哈"下一件最重要的事"。',
              '**天使投资和创业不能两全**。前者要广，后者要深。雷军没有"既做投资人又做 CEO"——他清空了投资身份。',
              '**看准窗口比看准赛道更重要**。雷军不是第一个看到智能手机机会的人，但他是 2010 年那个时间点 All In 进去的少数人。',
              '**40 岁创业不晚，但要梭哈**。任正非 43 岁，雷军 41 岁，王兴 33 岁——把全部押上去的时候，年龄只是数字。',
            ],
          },
        },

        {
          id: 'ch3-5',
          number: '05',
          title: '王兴 · 千团大战末班车（2012）',
          paragraphs: [
            '1979 年福建龙岩生。1996 年从福建龙岩一中考入清华电子工程系。2001 年清华本科毕业，去美国 University of Delaware 读博士。博士读了一半，2003 年辍学回国创业。',
            '王兴的前 8 年，是连续失败的 8 年：',
          ],
          list: {
            items: [
              '2003 年，多多友（仿 Friendster）。失败',
              '2004 年，游子图（照片分享）。失败',
              '2005 年，校内网。在清华、北大火爆，2006 年以 200 万美元卖给陈一舟（后来改名"人人网"）',
              '2007 年，饭否（仿 Twitter）。2009 年因敏感内容被关停 503 天，黄金窗口期错过',
              '2008 年，海内（企业版 Facebook）。失败',
            ],
          },
          paragraphsAfterList: [
            '到 2010 年 31 岁的王兴，已经连续创业 8 年，4 次明显失败。在硅谷的同龄朋友很多已经是百万富翁，他还在借钱发工资。',
            '2010 年 3 月 4 日，王兴上线美团网，仿 Groupon 的团购模式。但这次不一样——2010-2011 年中国掀起团购热潮，最高峰时全国有超过 5000 家团购网站。整个行业的剧本是：补贴用户、扩张城市、拉投资、再补贴、再扩张。',
            '王兴拒绝了这个剧本。',
            '他做了三件不一样的事。**不打补贴战**——所有竞争对手都在做"团购满 100 减 50"，美团坚持原价 + 商家服务质量。**狠抓 IT 系统**——当所有对手把钱花在地推、广告、用户补贴上，美团把一半的钱花在了打磨系统能力。**算账思维**——每开一个新城市，先看 ROI 模型，模型不通就不开。',
            '2011 年下半年，资本市场对团购模式从狂热转向怀疑。VC 的钱开始收紧。到 2011 年底，融不到钱的团购网站开始倒闭。2012 年是行业最惨烈的一年。',
          ],
          pullQuote: '"如果你拒绝失败，你也就拒绝了成功。"',
          paragraphsAfterQuote: [
            '王兴在那一年的内部信里说："我们已经撑过了千团大战。但战争不是结束，是开始。"那一年美团没有大量裁员，没有撤城，反而开始进军外卖业务——他押的下一个梭哈点。',
            '王兴的梭哈不是 "全部押在团购"——是"全部押在一家干十年的服务公司"。在融资紧张的 2011-2012 年，他做了一个反直觉的决定：**留两个月运营现金，剩下全部投入团队和系统**。',
            '竞争对手的做法是：账上有 6 个月的钱，那就花 5 个月烧补贴抢用户，剩下 1 个月再融资。如果融不到，公司死。',
            '王兴的做法是：账上有 6 个月的钱，留 2 个月当救命粮，4 个月用来雇人、做系统、打基础。如果融不到，公司还能活 2 个月——这 2 个月里继续做产品、做服务，等下一轮机会。',
            '这种算法听起来保守，但它本质是另一种 All In——**All In 在"长期主义"这个判断上**。',
            '2013 年，美团进入外卖。2015 年 10 月跟大众点评合并。2017 年进入打车业务。2018 年 9 月 20 日，美团在香港上市，市值 4000 亿港币。2020 年疫情爆发，美团外卖渗透率暴涨，市值峰值超过 2000 亿美元。',
          ],
          checklist: {
            items: [
              '**九败一胜**——如果你只能赢一次，那就一定要赢得彻底。',
              '**现金不是用来花的，是用来撑的**。在没看清楚战场之前，留出"够你看清楚"的现金缓冲。',
              '**不要陪对手玩你不擅长的游戏**。所有人都在烧钱，你冷静做产品；所有人在做产品，你冷静推渠道。永远在"对手最薄弱的维度"上 All In。',
              '**长期主义本身就是一种押注**。王兴梭哈的不是"团购会赢"，而是"用 10 年方式做事的人会赢"。',
            ],
          },
        },

        {
          id: 'ch3-6',
          number: '06',
          title: '赵长鹏 · 卖房梭哈比特币（2014）',
          paragraphs: [
            '赵长鹏（CZ）1977 年江苏连云港生。父亲是大学教师，因为政治原因被发配到偏远地区，1989 年全家移民加拿大温哥华。',
            '加拿大的青少年时代，CZ 在麦当劳打工、加油站值夜班、东京的寿司店做学徒——典型的"穷移民第二代"。1996 年考入麦吉尔大学（McGill）计算机系，毕业后进入彭博（Bloomberg），做交易系统的工程师。2005 年，他离开彭博创业，做高频交易系统 Fusion Systems，客户是华尔街的对冲基金。',
            '2013 年的某天，CZ 跟一个朋友吃晚饭。那个朋友花了一整顿饭跟他讲比特币。CZ 当时的反应：完全不理解。',
            '但是几天后，他研究了比特币的白皮书。再过几天，他读完了 Andreas Antonopoulos 的《Mastering Bitcoin》。再过几周，他飞到上海，找到 OKCoin（徐明星的），说他想加入。',
            '2014 年，CZ 在上海有一套房产（具体地点他没公开过，估计是市区）。他卖了。全部资金换成比特币。',
            '2014 年比特币价格在 200-700 美元之间波动（年初 800，年中 600，年底 320）。CZ 没有公开过他买入的均价，但根据 2014 年中位数估算，他大概买了 1000-3000 枚 BTC。',
            '这件事在 2014 年没什么人知道。直到 2018 年 CZ 接受访谈被问到："你最 All In 的一次决定是什么？"他才说："2014 年我把上海的房子卖了，全部买了比特币。"',
          ],
          pullQuote: '"我赌的不是比特币会涨。我是赌——加密货币会改变金融基础设施这件事一定会发生。"',
          paragraphsAfterQuote: [
            '"——可能 5 年，可能 10 年，可能 20 年，但一定会发生。如果发生，比特币是这个新世界里最确定的资产。如果不发生，那我就当我捐了一套房子。"',
            '那时候他已经在 OKCoin 工作，2015 年又去了 Blockchain.info。他不是炒币的人——他是搭建基础设施的人。',
            '2017 年 5 月，CZ 离开 OKCoin。6 月 26 日，币安（Binance）ICO 启动，募资 1500 万美元。7 月 14 日，币安交易所正式上线。11 个员工。一个简单的网站。一个简单的承诺：低手续费、多币对、技术稳定。',
            '2017 年 9 月 4 日，中国 7 部委联合发布《关于防范代币发行融资风险的公告》，全面禁止 ICO 和加密货币交易所。币安刚上线两个月，就要面对生死劫。',
            'CZ 的反应：当晚搬到日本。三天后整个团队从中国分散到东京、香港、马耳他、新加坡。币安成为一家"无国籍"公司。到 2017 年底，币安日活用户突破 600 万，成为全球第一大加密交易所。从启动到第一不到 180 天。',
            '2014 年卖房和 2017 年创办币安，是同一种思维的两次执行。**赌"基础设施"而不是"价格"**——CZ 从来没说过比特币会到 10 万美元，他只说过"加密金融基础设施一定会被建起来"。**当所有人都在害怕监管的时候，All In 监管套利**——2017 年中国禁令，是币安的最大机会，不是最大威胁。**把"无国籍"做成竞争力**——币安从第一天起就有 8 个国家的员工、4 种语言的客服、30+ 法币入金通道。',
            '2022 年 11 月 8 日: FTX 暴雷，CZ 拒绝救援，加速 SBF 倒台。币安趁势进一步抢市场。2023 年 11 月 21 日: 美国司法部宣布币安和 CZ 认罪，缴纳 43 亿美元罚款。CZ 辞去 CEO 职位，被判刑 4 个月。2024 年 4 月 CZ 服刑结束，下半年再次活跃，币安继续是全球最大交易所。',
          ],
          checklist: {
            items: [
              '**卖了房子的人不会回头**。CZ 2014 年卖房之后，再也没有"如果哪天我想退出还能回去"的退路——他被自己锁死了。这种锁死，往往是最大的执行力来源。',
              '**赌长期叙事而不是短期价格**。比特币 2014 年到 2024 年涨了 100 倍。但如果 CZ 当时是为了"涨 10 倍就卖"才买的，他早就退出了。买入"我不卖"才是真梭哈。',
              '**监管是机会，不是威胁**。每一次大监管事件，都会让一批"半信半疑"的玩家退出，留下"完全信"的玩家拿到所有市场。',
              '**基础设施 > 资产价格**。CZ 没有押 BTC 涨多少，他押的是"加密交易所"这个基础设施位置。结果是 BTC 涨 100 倍，币安涨 1000 倍。',
            ],
          },
        },

        {
          id: 'ch3-7',
          number: '07',
          title: '黄峥 · 三次重启（2015）',
          paragraphs: [
            '1980 年浙江杭州生。父母都是普通工人。从小成绩好，1998 年保送杭州外国语学校（杭外）。在杭外认识了一个改变他一辈子的人——段永平。两人通过一次校园活动认识，段永平当时已经是步步高的老板，回母校做客。',
            '2002 年浙大计算机本科毕业，黄峥获得段永平资助去 University of Wisconsin-Madison 读计算机硕士。2004 年硕士毕业，加入 Google 中国早期团队。',
            '2006 年 Google 在巴菲特午餐拍卖会上，段永平出资 62 万美元拍下机会，把黄峥带去见巴菲特和芒格——这是黄峥商业人生最重要的一课。',
            '2007 年 27 岁，黄峥从 Google 离职，第一次创业：欧酷网。2009 年 4500 万美元卖给兰亭集势。2009 年第二次创业：乐其代运营公司——帮宝洁、联合利华做电商代运营。2013 年第三次创业：寻梦游戏。',
            '到 2015 年 35 岁的黄峥，已经创办过三家公司：欧酷（卖掉）、乐其（盈利运营）、寻梦（盈利运营）。手上有钱、有团队、有资源。如果继续做这三家，他可以一辈子衣食无忧。但他做了第四次重启。',
            '2015 年 9 月，黄峥同时孵化两个新项目：拼好货（生鲜电商）和拼多多（杂货电商）。2016 年 9 月合并为"拼多多"。',
            '为什么是拼团？为什么是下沉市场？',
            '2015 年的中国电商已经是双寡头：京东 + 阿里。市场普遍认为，电商行业再没有创业机会。黄峥看到的不一样——"京东和阿里服务的是中国 5 亿城市人口。还有 5 亿农村和三四线人口，他们的需求和购买力没有被任何人服务。"',
          ],
          pullQuote: '"保持常识，远离喧嚣。"',
          paragraphsAfterQuote: [
            '拼多多的设计：**拼团**——利用社交关系裂变，降低获客成本到极致。**微信生态**——不开发独立 App，直接寄生在微信里。**白牌商品**——不卖品牌货，卖工厂货，价格压到京东淘宝的一半。**算法分发**——不做搜索，做推荐，让用户"刷"商品。',
            '所有这些选择都被同行嘲笑。"拼夕夕"、"假货"、"不上档次"——拼多多被骂了三年。但是用户在涨。2017 年拼多多年 GMV 突破千亿。',
            '黄峥的梭哈，是把"商业常识"全部押在了一个被嘲笑的方向上。**不打主流市场**——当所有人都盯着北上广深的精英用户，他押五环外人口。**反 App 思维**——当所有电商都在做独立 App，他押微信生态。**反品牌思维**——当所有电商都讲"消费升级"，他押"消费降级"。**反搜索思维**——当所有人都用搜索框做分发，他押算法推荐。',
            '每一条都是反主流。每一条都是基于他对"非互联网原住民"的深刻洞察。',
            '而且他自己有"段永平 + 巴菲特 + 芒格"三层导师。这三个人共同教会他一件事：**当你的逻辑跟主流相反的时候，先问"我看错了什么"，问完之后如果还坚持原判断，就 All In**。',
            '2018 年 7 月 26 日，拼多多在纳斯达克上市，市值 240 亿美元。当天黄峥 38 岁。2020-2021，拼多多 GMV 一度超越京东。2024 年拼多多市值峰值超过 2200 亿美元，海外品牌 Temu 在美国冲击亚马逊。',
            '2021 年 3 月，41 岁的黄峥宣布辞去 CEO，转入科研——投入生命科学和食品科学。他在公开信里说："我累了。我想用剩下的人生研究我真正好奇的事。"',
          ],
          checklist: {
            items: [
              '**重启不丢人**。黄峥 35 岁的时候已经做了三家公司，他没有"在路径依赖里继续"。每一次他都问自己："这是不是 10 年后还想做的事？"',
              '**反主流的判断需要更深的研究**。如果你的结论跟所有人都不一样，那要么你看到了别人没看到的，要么你看错了。多问自己几遍"我可能错在哪里"。',
              '**导师的复利**。段永平 → 巴菲特 → 芒格，三层导师把价值投资的世界观完整传递给了黄峥。重要决策时，能借用别人 50 年的智慧。',
              '**退出比进场难**。黄峥 41 岁退休去做科研，是另一种意义上的梭哈——把后半生 All In 在一件不会立刻有回报的事上。',
            ],
          },
        },

        {
          id: 'ch3-8',
          number: '08',
          title: '张一鸣 · 抖音出海（2016）',
          paragraphs: [
            '1983 年福建龙岩生。跟王兴是龙岩老乡，都毕业于龙岩一中。父亲是机关干部，母亲是护士。',
            '2001 年考入南开大学微电子专业，因为对软件更感兴趣，2003 年转专业到软件工程。在南开期间他读完了几乎所有计算机经典，并开始为开源项目贡献代码。',
            '2005 年毕业。2005-2009 期间换了几家公司：IBM 实习（无聊辞职）、酷讯旅游搜索（一年从工程师做到技术主管）、饭否（王兴的第二家公司）、九九房（自己创业）。',
            '到 2011 年 28 岁，张一鸣已经历 4 家公司、3 次明显失败。他在反思一件事：**为什么互联网行业的所有内容分发，都还是编辑推荐？**',
            '2012 年 3 月 9 日，字节跳动成立。同年 8 月，今日头条 1.0 上线。',
            '今日头条的核心创新是：**算法推荐，不是编辑推荐**。这在 2012 年的中国是离经叛道。当时所有内容平台——新浪、网易、搜狐、腾讯——都是编辑选稿、首页置顶、用户被动接受。算法推荐被视为"低俗"、"标题党的温床"、"机器无法理解内容"。',
            '张一鸣的判断：算法 + 数据 = 比编辑更懂用户。',
            '但前两年不顺利。2012-2013 头条增长缓慢，融资被拒了几十次（大部分 VC 不相信算法推荐能成主流）。2014 年 6 月红杉投资头条 C 轮，估值 5 亿美元，是算法路线的第一个大玩家。2014-2016 是头条爆发期。月活用户从 1000 万涨到 1.5 亿。',
            '2016 年 9 月，字节跳动上线短视频 App，改名"抖音"。2017 年抖音 DAU 突破 5000 万，2018 年突破 2 亿。',
            '但更关键的决定，是出海。',
            '2017 年 11 月，字节跳动以 10 亿美元收购 Musical.ly。2018 年 8 月把 Musical.ly 跟海外版抖音合并为 TikTok。',
            '那时候字节跳动账上的钱不超过 30 亿美元。这一笔 10 亿收购，是把账上 1/3 的钱押在了一件没人确定能成的事上——中国 App 出海到欧美 C 端市场，从来没成功过（微信、QQ 在海外市场都失败了）。',
            '张一鸣却把字节跳动接下来 5 年的资源和人才 70% 倾斜到了 TikTok。',
          ],
          pullQuote: '"延迟满足感，是把人生当作一场无限游戏来玩的能力。"',
          paragraphsAfterQuote: [
            '张一鸣的"延迟满足感"哲学，在出海这件事上体现得最明显。2016-2017 年的中国互联网，所有人都在抢"国内 BAT 之外的红利"。但张一鸣判断：',
            '第一，**国内市场的天花板不够高**。今日头条已经做到中国 1.5 亿月活，再涨空间有限。',
            '第二，**算法 + 短视频 + 推荐流，是普世内容产品**。这个组合不依赖于具体的中国国情，理论上可以服务全世界。',
            '第三，**没有任何中国互联网公司在 C 端真正打入欧美**。如果有人能做到，那就是这一代里最大的红利。',
            '第四，**出海赌的不是市场份额，是话语权**。一个中国公司在美国市场拿到 1 亿用户，等于一个新冷战时代的"软实力武器"。',
            '押 70% 的资源给一个不确定的事，只有相信"延迟满足感"的人才做得到。',
            '2019 年 TikTok 在美国 DAU 突破 4000 万。2020 年特朗普想禁 TikTok，最终未成。2021 年 TikTok 全球月活突破 10 亿。2024 年字节跳动估值约 3000-5000 亿美元（一级市场估值）。',
            '2021 年 5 月 20 日，张一鸣 38 岁，宣布辞去 CEO，由梁汝波接任。他在内部信里说："我想放下日常管理，去思考一些 5-10 年的事。"',
          ],
          checklist: {
            items: [
              '**算法是这个时代最被低估的人类发明**。2012 年的张一鸣判断"算法 + 内容"会重塑分发权，10 年后这个判断价值万亿。',
              '**延迟满足感不是不下注，是下大注**。看似"等"的人，往往在等到位之后下了别人想都不敢想的注。',
              '**国际化不是销售扩张，是产品基因**。从第一天就为全球设计的产品，10 年后能拿全球。从中国市场起家再考虑出海的产品，几乎都会卡在文化壁垒上。',
              '**反共识三次以上的人才能成大事**。算法推荐反 2012 共识、抖音反 2016 短视频共识、出海反 2017 中国互联网共识。每次都对了。',
            ],
          },
        },

        {
          id: 'ch3-9',
          number: '09',
          title: '孙宇晨 · 镜头前的梭哈（2017）',
          paragraphs: [
            '1990 年青海西宁生。父亲是中学语文老师。高中开始写作，2007 年获得新概念作文一等奖。2008 年从北京大学历史系本科入学。2013 年北大本科毕业，去美国宾夕法尼亚大学读硕士。',
            '2013 年加入 Ripple 担任大中华区代表。两年后离职，自己单干。',
            '2017 年 8 月 28 日，27 岁的孙宇晨发起波场（TRON）的 ICO，募集 7000 万美元。2017 年 9 月 4 日，中国 7 部委联合发布《关于防范代币发行融资风险的公告》。所有 ICO 项目被要求停止募资、退还资金。波场首当其冲。外界普遍认为：波场已死。',
            '但孙宇晨没有走传统路线。他在镜头前——多次直播、多次访谈——明确表态："All In! 我个人全部身家都在波场上。"',
            '这不是营销话术。这是一种姿态——把自己的退路彻底烧掉，让所有可能犹豫的投资人和持有者看到："我没有 plan B。"',
            '2018 年 6 月 25 日，TRON 主网正式上线。同年 7 月，TRON 收购 BitTorrent（1.4 亿美元），成为加密圈第一笔大型并购。',
            '2018 年底波场已经是全球前十的公链，TRX 流通市值最高超过 100 亿美元。',
          ],
          pullQuote: '"All In!"',
          paragraphsAfterQuote: [
            '孙宇晨的梭哈，是有争议的——业内对他评价两极。但抛开争议看决策，他的"All In!"姿态本身改变了几件事。',
            '第一，**让"梭哈"这个词在中文加密圈固化**。在他之前，中文圈的对应词是"梭哈"或"重仓"，但都不够口号化。他在镜头前喊出 "All In!" 之后，这两个英文字母成了一种文化符号。',
            '第二，**用"个人 All In"代替"团队 All In"**。传统创业项目都是团队信用，但波场是孙宇晨一个人的信用。他赌的是：如果你相信我，你就持有 TRX。如果你不相信我，你就走。这种激进的"个人化承诺"，成为后来很多 meme 币和加密 KOL 项目的模板。',
            '第三，**监管打压期反向行动**。2017 年 9 月禁令之后，理性反应是退出市场、转型、收缩。孙宇晨的反应是：搬到海外、加码投入、加倍曝光。这种"逆向 All In"，跟马斯克 2008 年押第四发是同一种逻辑——别人在撤退的时候，你 All In。',
            '2019 年 6 月，孙宇晨花 457 万美元拍下"巴菲特午餐"——史上最高价。后因身体原因推迟，2022 年 5 月才完成。',
            '2020-2021 加密大牛市，TRX 涨幅可观，TRON 成为 USDT 主要发行链（峰值时 TRC20-USDT 流通超 500 亿美元）。但争议持续。2023 年 SEC 起诉孙宇晨涉嫌操纵市场。USDD 算法稳定币在 2022 年面临脱锚危机。',
            '到 2024-2025 年，TRX 仍是全球前十大币种之一，孙宇晨仍然是加密圈最具话题性的中国创业者。',
          ],
          checklist: {
            items: [
              '**公开 All In 是一种自缚式承诺**。当你在镜头前说出"我全部身家都在这"，你就给自己做了一个不能反悔的承诺。这种"自缚"本身是执行力。',
              '**"梭哈"作为文化符号的力量**。一个词、一个口号、一种姿态，有时候比商业模式更能聚集共识。',
              '**争议 + All In 共存**。每一个把全部押上去的人，都会有争议。如果一个创业者从来没被骂过，可能是因为他没真的押上全部。',
              '**逆向行动是 All In 的基本姿势**。监管禁令、市场恐慌、舆论围剿——这些时刻反而是 All In 的最佳窗口。',
            ],
          },
        },
      ],
      paragraphsTail: [
        '九个故事讲完了。',
        '我们没有收录所有应该被收录的人。这一卷是一个开始——后续每一篇社区投稿入选的故事，都会编入这份名单的延续。',
        '如果你身边有这样的人，或者你自己就是这样的人——请投稿。',
        '一份长名单，刚刚开始。',
      ],
    },

    {
      id: 'ch4',
      kind: 'chapter',
      number: 'IV',
      title: '社区共建',
      paragraphs: [
        'ALLIN 不是一个人能写完的项目。这一章讲清楚：你怎么贡献，我们怎么收录，激励怎么发。',
      ],
      subsections: [
        {
          id: 'ch4-1',
          number: 'i',
          title: '谁可以投稿',
          paragraphs: [
            '任何人都可以投稿一个梭哈故事。',
            '我们接受三种来源：',
          ],
          checklist: {
            items: [
              '**个人故事**——你自己经历过的梭哈时刻',
              '**亲历者代笔**——你身边的人经历过的、你愿意为他写的故事',
              '**研究式投稿**——你研究过的某个公开人物的梭哈时刻，且引用资料可以追溯到原始来源',
            ],
          },
          paragraphsTail: [
            '第三类是目前《梭哈者列传》主要的来源。第一类正在快速增长——我们已经收到了几十份匿名投稿，正在评审。',
          ],
        },
        {
          id: 'ch4-2',
          number: 'ii',
          title: '入选标准',
          paragraphs: [
            '不是每一次"All in"都算梭哈。我们的入选标准很严格。一个故事要被收录，必须满足下面三条**全部**：',
          ],
          checklist: {
            items: [
              '**条件一 · 必须押"全部可输的"**——押了 10% 不算梭哈，押了 50% 也不算。必须是"如果失败，将立刻陷入实质性困境"的程度——卖掉房子、清空账户、抵押资产、放弃稳定收入、推掉所有备选项。我们要看到具体的资产数字、收入断流、退路被切。',
              '**条件二 · 必须有明确的决策时刻**——"我做了 10 年这件事"不算梭哈。我们要看到一个具体的时刻：某一天、某一个会议、某一句话、某一个签字——决策被做出了。这个时刻可能是"早上喝粥的那一刻"，可能是"晚上签合同的那一刻"。但必须是一个时间戳。',
              '**条件三 · 必须有可验证的结果**——不论结果是成功还是失败，必须有公开可查的"后续"：产品上线了、公司倒闭了、市值变了、资金流向变了。失败的故事跟成功的一样有价值，前提是失败本身可以被诚实记录下来。',
            ],
          },
          paragraphsTail: [
            '三条缺一不可。',
            '我们也会收录"失败的梭哈"——这种故事不应该被埋掉。一个把全部押上去然后输掉的人，跟一个把全部押上去然后赢的人，承担的勇气是一样的。',
          ],
        },
        {
          id: 'ch4-3',
          number: 'iii',
          title: '投稿流程与激励',
          paragraphs: [
            '准备 1500-2000 字的中文故事，按"背景 / 关键时刻 / 决策逻辑 / 后续 / 启示"五段结构。引用至少 3 个公开来源（个人故事可以是当事人亲述 + 时间戳；公开人物必须是新闻、年报、传记等可验证资料）。投稿到 Telegram（@allin_submissions）或 GitHub PR（allin/manifesto repo）。社区匿名评审，通常 2-4 周给出回复。',
            '社区池一共 10% 的代币，合约确认后会单独地址锁定。分配方式：',
          ],
          checklist: {
            items: [
              '每一个被收录的故事，作者获得固定 30 万 ALLIN 基础奖励',
              '每被引用 / 转发 / 翻译 1000 次，作者额外获得 5 万 ALLIN',
              '翻译者（中→英、中→其他语言）获得原作者 30% 的奖励比例',
              '前 100 篇收录的故事，作者获得"创世贡献者"标识——链上 NFT，永久铭牌',
            ],
          },
          paragraphsTail: [
            '但坦诚说：金额不是重点。被收录在这份宣言里、被链上永久记录、被所有未来的 ALLIN 持有者读到——这才是核心激励。',
            '关于治理：ALLIN 不是 DAO，不会做"代币投票治理路线图"那种秀。但我们会做下面这些：入选标准的修订，由社区核心贡献者集体讨论。重大决策（例如未来融资、是否上 CEX）通过社区签名公告。代币分配的执行，每月链上公开记录。任何修改宣言文字的提议，必须经过 14 天公示期。',
          ],
          pullQuote: '少做承诺，做了就兑现。',
        },
      ],
    },

    {
      id: 'ch5',
      kind: 'chapter',
      number: 'V',
      title: '机制与透明度',
      paragraphs: [
        '这一章本来可以写很长——把链、合约、分配、安全审计、流动性证明全部展开。但我们选择写短。',
        '因为这些东西，链上一查就有，不需要我们用文字再描述一遍。',
      ],
      subsections: [
        {
          id: 'ch5-1',
          number: 'i',
          title: '基础信息',
          checklist: {
            items: [
              '**链** · BNB Chain（BSC）',
              '**合约地址** · 0x234c3bFC260277cb4497E498A83aB685E30Ac730',
              '**代币标准** · BEP-20',
              '**总供应量** · 1,000,000,000 ALLIN',
              '**小数位** · 18',
              '**DEX** · PancakeSwap V2',
              '**交易对** · ALLIN/USDT，pair address 0xa6c24770d62b156115198de3fcc9be9e70bf975e',
              '**行情数据** · DexScreener / GeckoTerminal / CMC（陆续上线）',
            ],
          },
        },
        {
          id: 'ch5-2',
          number: 'ii',
          title: '代币分配',
          paragraphs: [
            '**公开流动性 85%**——上线即注入 PancakeSwap，LP 永久销毁。链上可证明的销毁交易记录在合约创建后 24 小时内执行。',
            '**社区激励 10%**——用于《梭哈者列传》投稿激励、翻译激励、社区贡献奖励。地址公开，每月链上记录支出。',
            '**市场曝光 5%**——用于 KOL、媒体、社区活动。地址公开，每一笔支出在 24 小时内推特公示。',
            '**团队预留 0%**——没有。我们不留。',
          ],
        },
        {
          id: 'ch5-3',
          number: 'iii',
          title: 'LP 销毁与数据看板',
          paragraphs: [
            'LP 销毁的交易 hash 链上可查。这是最关键的一笔交易——它证明了我们没有"撤池子"的能力。任何人都可以在 BscScan 上验证：合约创建 → 添加流动性 → 把 LP 代币转入 0x000…dead 地址。',
            '如果你看不懂这些技术细节，你只需要记住一件事：**LP 销毁之后，这枚代币的池子永远不会被项目方撤走，任何人都不会**。',
            '官网首页的四个实时数据卡——市值、持有人数、24h 交易量、池子 USDT——数据来自 DexScreener API + GoPlus Security API。每 60 秒自动刷新，浏览器开发者工具可以验证请求。任何人发现数据异常，可以在 Telegram 反馈。',
          ],
        },
        {
          id: 'ch5-4',
          number: 'iv',
          title: '我们没有的',
          paragraphs: [
            '为了让你确切地知道这枚代币是什么，我们也列一下"我们没有的"：',
          ],
          checklist: {
            items: [
              '没有审计——合约太简单，60 行代码内可读完，一个标准 BEP-20 加 LP 销毁',
              '没有质押合约',
              '没有锁仓机制（除了 LP 永久销毁）',
              '没有跨链桥',
              '没有 governance token——持有 ALLIN 不会给你投票权',
              '没有空投承诺——从来没说过会空投，将来也不会突然宣布',
            ],
          },
          paragraphsTail: ['简单是这枚代币的设计原则。'],
        },
      ],
    },

    {
      id: 'ch6',
      kind: 'chapter',
      number: 'VI',
      title: '这不是什么',
      paragraphs: [
        '这一章用来划清边界。',
        '在加密世界里，每一个新代币都会被以下问题轰炸：你是不是 L1？你解决什么问题？你有什么 utility？你跟某某项目什么关系？',
        '为了让所有人都不再问这些问题，我们直接答清楚。',
      ],
      subsections: [
        {
          id: 'ch6-1',
          number: 'i',
          title: '我们不是',
          checklist: {
            items: [
              '**不是 L1**——我们不是新一条公链，我们就是 BNB Chain 上的一枚 BEP-20 代币',
              '**不是 DeFi 协议**——没有 lending / swap / staking / yield 任何金融功能',
              '**不是 RWA token**——没有抵押任何现实资产',
              '**不是 governance token**——持有它不会给你任何项目投票权',
              '**不是 utility token**——它没有具体的"使用场景"，你不能用它解锁任何功能、买任何商品、获得任何服务',
              '**不是空投币**——没有空投计划，也不会有"突然宣布"的空投',
              '**不是任何热点的拼接**——RWA / IDO / Restaking / DePIN，这些跟 ALLIN 都没关系',
            ],
          },
        },
        {
          id: 'ch6-2',
          number: 'ii',
          title: '那 ALLIN 是什么',
          paragraphs: [
            'ALLIN 是一座纪念碑。一份名单。一种暗号。',
            '它的全部价值，来自持有者对"看懂了就梭哈"这种精神的认同。它没有承诺收益，没有实用功能，没有未来路线图。',
            '这听起来不像投资标的。是的，**它本来就不是**。',
          ],
          pullQuote: '它的价值不是金融式的，是文化式的——你认同这种精神，你就买；你不认同，你就走。',
        },
        {
          id: 'ch6-3',
          number: 'iii',
          title: '关于风险与司法辖区',
          paragraphs: [
            '这枚代币可以归零。',
            '如果某一天 ALLIN 的市场不再相信这种精神，价格会归零。如果某一天社区共识溃散，价格会归零。如果某一天监管完全禁止此类社区代币，价格会归零。',
            '我们对这种归零 100% 知情，并且把这种"归零的可能性"写进了所有公开材料里。',
            '请用你输得起的钱押。',
            'ALLIN 不是任何司法辖区的证券要约。本宣言不构成投资建议、不构成要约、不构成劝诱购买。如果你所在的国家或地区禁止持有加密资产，请遵守你当地的法律。ALLIN 不会主动进入任何明显违反加密监管的市场。',
          ],
        },
      ],
    },

    {
      id: 'postscript',
      kind: 'chapter',
      number: '',
      title: '后记',
      paragraphs: [
        '如果你读到这里——',
        '你已经知道了《梭哈宣言》的全部内容。前言、为什么是 ALLIN、三条精神原则、九个人的故事、社区共建规则、机制透明度、和这枚代币不是什么。',
        '我们不再说服你。',
        '如果这份文字打动了你，欢迎入桌。买一些 ALLIN，加入 Telegram 社区，给我们投稿你身边的梭哈故事，或者，干脆什么都不做——只是把这份宣言转发给一个你认识的、正在悬崖边上犹豫的朋友。',
        '如果这份文字没有打动你，没关系。这本就不是一份给所有人的文字。',
        '我们想留下的，不是一个十亿美元的 token，是一份一百年后还有人读的中文文档——记录这一代里把全部押在一件事上的人，记录他们在那一刻的勇气，记录"梭哈"这个词曾经被严肃地、认真地、不带嘲讽地使用过。',
      ],
      pullQuote: '被记下，是一种古老的奖励。它比 token 古老得多，可能也持久得多。',
      sign: '——ALLIN 社区，2026 年春天',
    },
  ],
};
